import { setCookie, getCookie } from "./commonFunction";

// The admin console uses its OWN token, separate from the site's dahrToursUserToken,
// so this section is independent of the main app's WP-redirect auth flow.
const TOKEN_KEY = "dahrAdminToken";
const USER_KEY = "dahrAdminUser";

export const setAdminAuth = (token, user, expiresInSeconds) => {
  const hours = expiresInSeconds
    ? Math.max(1, Math.floor(Number(expiresInSeconds) / 3600))
    : 12;
  setCookie(TOKEN_KEY, token || "", hours);
  try {
    setCookie(USER_KEY, encodeURIComponent(JSON.stringify(user || {})), hours);
  } catch (e) {
    /* ignore serialization issues */
  }
};

export const getAdminToken = () => getCookie(TOKEN_KEY) || "";

export const getAdminUser = () => {
  try {
    const raw = getCookie(USER_KEY);
    return raw ? JSON.parse(decodeURIComponent(raw)) : null;
  } catch (e) {
    return null;
  }
};

export const clearAdminAuth = () => {
  setCookie(TOKEN_KEY, "", -1);
  setCookie(USER_KEY, "", -1);
};
